module.exports = __webpack_public_path__ + "static/img/sign.c9b6462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sign.jpg
// module id = KkFl
// module chunks = 9